export default __webpack_public_path__ + "static/media/closs-system.8e4be879.png";